"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const string_1 = require("../../../../../utilities/string");
const constants_1 = require("../../../constants");
const convert_1 = require("./convert");
const a11y_1 = require("./a11y");
const whiteColor = (0, convert_1.hexToOklch)("#ffffff");
const blackColor = (0, convert_1.hexToOklch)("#000000");
const generateMetaColors = (definition, themeOptions = {}) => {
    if (!definition.color)
        return;
    const { onColorValues = {}, colorContrastAlgorithm } = themeOptions;
    const result = {};
    Object.keys(definition.color).forEach((tokenName) => {
        const bgToken = definition.color?.[tokenName];
        const generatedForegroundName = `on${(0, string_1.capitalize)(tokenName)}`;
        const generatedRGBName = `rgb${(0, string_1.capitalize)(tokenName)}`;
        const generateOnColorsFor = [
            ...constants_1.bgWithDynamicForeground,
            ...(themeOptions?.generateOnColorsFor || []),
        ];
        const needsDynamicForeground = generateOnColorsFor.includes(tokenName) && !definition.color?.[generatedForegroundName];
        const needsRGB = tokenName.startsWith("background") ||
            tokenName.endsWith("black") ||
            tokenName.endsWith("white");
        if (!bgToken)
            return;
        const oklchBgToken = (0, convert_1.tokenToOklchToken)(bgToken);
        if (needsDynamicForeground) {
            const overrideKeys = Object.keys(onColorValues);
            const onColorKey = overrideKeys.find((key) => tokenName.toLowerCase().includes(key));
            const onColor = onColorKey && onColorValues[onColorKey];
            const lightColor = onColor && "hexLight" in onColor
                ? (0, convert_1.hexToOklch)(onColor.hexLight)
                : onColor?.oklchLight || whiteColor;
            const darkColor = onColor && "hexDark" in onColor
                ? (0, convert_1.hexToOklch)(onColor.hexDark)
                : onColor?.oklchDark || blackColor;
            const light = (0, a11y_1.getOnColor)({
                bgColor: oklchBgToken.oklch,
                lightColor: { ...lightColor, mode: "oklch" },
                darkColor: { ...darkColor, mode: "oklch" },
                algorithm: colorContrastAlgorithm,
            });
            const dark = oklchBgToken.oklchDark &&
                (0, a11y_1.getOnColor)({
                    bgColor: oklchBgToken.oklchDark,
                    lightColor: { ...lightColor, mode: "oklch" },
                    darkColor: { ...darkColor, mode: "oklch" },
                    algorithm: colorContrastAlgorithm,
                });
            result[generatedForegroundName] = {
                oklch: light,
                oklchDark: dark,
            };
        }
        if (needsRGB) {
            const rgb = (0, convert_1.oklchToRgb)(oklchBgToken.oklch);
            const rgbDark = oklchBgToken.oklchDark && (0, convert_1.oklchToRgb)(oklchBgToken.oklchDark);
            result[generatedRGBName] = {
                hex: `${rgb.r * 255}, ${rgb.g * 255}, ${rgb.b * 255}`,
                hexDark: rgbDark && `${rgbDark.r * 255}, ${rgbDark.g * 255}, ${rgbDark.b * 255}`,
            };
        }
    });
    return result;
};
exports.default = generateMetaColors;
